import React from "react";
import { showAdequateDifferenceInTime } from "react/utils/utils";

class ResequenceItem extends React.PureComponent {

  printComparisons = (string, circleColor) => (
    <div className="item">
      <div className={`circle ${circleColor}`}/>
      <div className="information">{string}</div>
    </div>
  )

  getIconType(confirmed) {
    switch (confirmed) {
      case undefined: 
        return 'pending';
      case true: 
        return 'confirmed';
      case false: 
        return 'rejected';
      default: 
        return null;
    }
  }

  renderSuggestionWithChanges(icon) {
    const {
      sameStop,
      description,
      comparedTime,
      comparedTimeWindow,
      comparedDistance,
    } = this.props;

    const timeCircleColor = comparedTime <= 0 ? 'green' : 'red';
    const distanceCircleColor = comparedDistance <= 0 ? 'green' : 'red';
    const timeWindowCircleColor = comparedTimeWindow <= 0 ? 'green' : 'red';

    const suggestionString = icon === 'rejected' ? 'suggested' : 'adjusted';

    const formattedTime = showAdequateDifferenceInTime(comparedTime);
    const timeString = comparedTime > 0 ? `+${formattedTime}` : `-${formattedTime}`;

    const formattedDistance = new Monet.Format.DISTANCE(comparedDistance).toGrid().getValue();
    const distanceString = comparedDistance > 0 ? `+${formattedDistance}` : `${formattedDistance}`;

    const timeWindowString = comparedTimeWindow > 0 ? `+${comparedTimeWindow}` : `${comparedTimeWindow}`;
    const nextStopString = Monet.I18n.getResourcesByKey(`resequenceTrigger.nextStop.${suggestionString}`);
    const timeComparedString = Monet.I18n.getResourcesByKey('resequenceTrigger.timeComparison');
    const distanceComparedString = Monet.I18n.getResourcesByKey('resequenceTrigger.distanceComparison');
    const timeWindowComparedString = Monet.I18n.getResourcesByKey('resequenceTrigger.timeWindowComparison');

    return (
      <div>
        { !sameStop ?
          <div className="suggestion">{`${nextStopString} ${description}.`}</div> : 
          null
        }
        <div className="comparisons">
          {comparedTime ? this.printComparisons(`${timeComparedString}: ${timeString}`, timeCircleColor) : null}
          {comparedDistance ? this.printComparisons(`${distanceComparedString}: ${distanceString}`, distanceCircleColor) : null}
          {comparedTimeWindow ? this.printComparisons(`${timeWindowComparedString}: ${timeWindowString}`, timeWindowCircleColor) : null}
        </div>
      </div>
    )
  }

  render() {
    const {
      hour,
      sameStop,
      confirmed,
      toggleState,
      comparedTime,
      comparedDistance,
      resequenceTrigger,
      comparedTimeWindow,
    } = this.props;

    const icon = this.getIconType(confirmed);

    const noChanges = sameStop && !comparedTime && !comparedDistance && !comparedTimeWindow;

    const triggerString = Monet.I18n.getResourcesByKey(`resequenceTrigger.${resequenceTrigger}`);
    const afterString = Monet.I18n.getResourcesByKey(`resequenceTrigger.resequencedAfter`);
    const noChangesString = Monet.I18n.getResourcesByKey('resequenceTrigger.noChanges');

    if (toggleState && noChanges) {
      return null;
    }

    return (
      <div className="resequenceItem">
        <div className="hourContainer">
          <div className={icon}/>
          <div className="hour">{hour}</div>
        </div>
        <div className="trigger">{`${afterString}: ${triggerString}.`}</div>
        {
          noChanges ? (
            <div className="suggestion">{noChangesString}</div>
          ) : (
            this.renderSuggestionWithChanges(icon)
          )
        }
      </div>
    );
  }
}

export default ResequenceItem;
